<template>
  <span :class="['wa-badge', `wa-badge--${variant}`]">
    <span class="wa-badge__dot"></span>
    {{ label }}
  </span>
</template>

<script>
const STATUS_MAP = {
  // Mensaje status
  queued: { label: "En cola", variant: "gray" },
  sent: { label: "Enviado", variant: "blue" },
  delivered: { label: "Entregado", variant: "teal" },
  read: { label: "Leído", variant: "green" },
  failed: { label: "Fallido", variant: "red" },
  // Template status
  draft: { label: "Borrador", variant: "gray" },
  submitted: { label: "En revisión", variant: "amber" },
  approved: { label: "Aprobada", variant: "green" },
  rejected: { label: "Rechazada", variant: "red" },
  paused: { label: "Pausada", variant: "amber" },
  disabled: { label: "Desactivada", variant: "gray" },
  // Connection status
  active: { label: "Conectado", variant: "green" },
  disconnected: { label: "Desconectado", variant: "gray" },
  connecting: { label: "Conectando", variant: "amber" },
  suspended: { label: "Suspendido", variant: "red" }
};

export default {
  name: "WhatsappStatusBadge",
  props: {
    status: { type: String, required: true }
  },
  computed: {
    config() {
      return STATUS_MAP[this.status] || { label: this.status, variant: "gray" };
    },
    label() {
      return this.config.label;
    },
    variant() {
      return this.config.variant;
    }
  }
};
</script>

<style scoped>
.wa-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.wa-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Variants */
.wa-badge--green {
  background: #d1fae5;
  color: #065f46;
}
.wa-badge--green .wa-badge__dot {
  background: #10b981;
}

.wa-badge--teal {
  background: #d0faf5;
  color: #0e5f55;
}
.wa-badge--teal .wa-badge__dot {
  background: #3ecfb4;
}

.wa-badge--blue {
  background: #dbeafe;
  color: #1e40af;
}
.wa-badge--blue .wa-badge__dot {
  background: #3b82f6;
}

.wa-badge--amber {
  background: #fef3c7;
  color: #92400e;
}
.wa-badge--amber .wa-badge__dot {
  background: #f59e0b;
}

.wa-badge--red {
  background: #fee2e2;
  color: #991b1b;
}
.wa-badge--red .wa-badge__dot {
  background: #ef4444;
}

.wa-badge--gray {
  background: #f3f4f6;
  color: #6b7280;
}
.wa-badge--gray .wa-badge__dot {
  background: #9ca3af;
}
</style>
